export type GroupsType<T> = Record<string | number, T[]>

export default function groupBy<T>(list: T[], callback: (group: T, index: number) => string) {
    return list.reduce<GroupsType<T>>((groups, item, index) => {
        const field = callback(item, index)
        const group = groups[field] || []
        group.push(item)
        groups[field] = group
        return groups
    }, {})
}
